export const getDisclaimerNumber = (key: string) => {
  const order = ["tire_tax", "dealer_fee", "electric_incentive", "calculation", "product"];
  const index = order.findIndex(x => x === key);
  if (index < 0) {
    console.log("no index found");
    return undefined;
  }
  return index + 1;
}
